import { useSelector } from 'react-redux';
import { RootState } from '../appReducer';
import { UseSelectOrdersTypes } from '../ordersTable/types';

const useOrdersData = (): UseSelectOrdersTypes => {
  const { items, totalCount, loading } = useSelector(
    (state: RootState) => state.orders
  );

  return {
    loading,
    ordersList: items,
    totalCount,
  };
};

export default useOrdersData;
